export const USER_AUTH_SUCCESS = 'USER_AUTH_SUCCESS';
